module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "inner-header clearfix"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 3,
      "md": 3,
      "lg": 3
    }
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toWelcomePage
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 21,
      "md": 21,
      "lg": 21
    }
  }, [_c('div', {
    staticClass: "user-box"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "https://docs.qq.com/doc/DVUx3YW5GZWxsdWVx"
    }
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.showUserInfo
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "linka",
    on: {
      "click": _vm.userLogout
    }
  }, [_vm._v("退出")])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e3d0e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 679
// module chunks = 1